export enum ParkingAvailabilityTier {
	NOW = 'Now',
	LATER = 'Later',
	NEVER = 'Never',
}
